import type { ReactNode } from "react";
import {
	useBodyClass,
	useCartCount,
	useDisclosure,
	useEscapeKey,
	useFirstVisit,
	useScrolledPast,
} from "../../hooks";
import { mainNav, sideNav } from "../../data";
import { Header } from "./Header";
import { SideMenu } from "./SideMenu";
import { Footer } from "./Footer";

type LayoutProps = {
	children: ReactNode;
};

/**
 * Casca do site: concentra o estado de UI compartilhado (menu, scroll) e o
 * distribui para cabeçalho, gaveta e rodapé.
 */
export function Layout({ children }: LayoutProps) {
	const menu = useDisclosure();
	const scrolled = useScrolledPast(40);
	const firstVisit = useFirstVisit();
	const cartCount = useCartCount();

	useBodyClass("menu-opened", menu.isOpen);
	useBodyClass("header-reduced", scrolled);

	useEscapeKey(menu.isOpen, menu.close);

	return (
		<>
			<Header
				nav={mainNav}
				cartCount={cartCount}
				menuOpen={menu.isOpen}
				onToggleMenu={menu.toggle}
				firstVisit={firstVisit}
			/>

			<SideMenu items={sideNav} open={menu.isOpen} onClose={menu.close} />

			<main id="inici">{children}</main>

			<Footer />
		</>
	);
}
